"use client";

import { zodResolver } from "@hookform/resolvers/zod";
import Link from "next/link";
import { useForm } from "react-hook-form";
import z from "zod";

import { Button, buttonVariants } from "@/components/ui/button";
import { Field, FieldGroup, FieldLabel, FieldSet } from "@/components/ui/field";
import { Input } from "@/components/ui/input";

interface Step1Props {
  onNext: (email: string) => void;
}

const emailSchema = z.object({
  email: z.string().min(1, "이메일을 입력해 주세요").email("올바른 이메일 형식이 아닙니다"),
});

type FormValues = z.infer<typeof emailSchema>;

export default function Step1EmailForm({ onNext }: Readonly<Step1Props>) {
  const {
    register,
    formState: { errors },
    watch,
    trigger,
  } = useForm<FormValues>({
    resolver: zodResolver(emailSchema),
    mode: "onChange",
  });

  const emailValue = watch("email");

  const handleSubmitStep = async () => {
    const isValid = await trigger("email");
    if (!isValid) {
      return;
    }
    onNext(emailValue);
  };

  return (
    <FieldSet>
      <FieldGroup>
        <Field>
          <FieldLabel className="text-base">이메일</FieldLabel>
          <Input
            {...register("email")}
            placeholder="가입한 이메일을 입력해 주세요"
            onChange={e => {
              register("email").onChange(e);
              trigger("email");
            }}
            className="h-11 text-base"
            aria-invalid={!!errors.email}
          />
          {errors.email && <p className="text-error-600 text-sm">{errors.email.message}</p>}
        </Field>

        <Field className="pt-2">
          <Button
            type="button"
            onClick={handleSubmitStep}
            disabled={!emailValue || !!errors.email}
            className="text-md h-11"
          >
            인증코드 발송
          </Button>
        </Field>

        <div>
          <Link href="/sign-in" className={buttonVariants({ variant: "link", size: "sm" })}>
            로그인으로 돌아가기
          </Link>
        </div>
      </FieldGroup>
    </FieldSet>
  );
}
